import { useEffect } from "react";
import { Link } from "react-router-dom";

const CAPABILITIES = [
  "Soils, acid sulfate soils (ASS), and erosion and sediment control (ESC)",
  "Ecology and offsets",
  "Marine and coastal field work",
  "Bushfire risk and bushfire hazard management plans (BHMP)",
  "Construction environmental management plans (CEMP) and compliance",
  "Approvals packages",
  "Drill-programme and exploration field support, including coordination, RFQs, and site programmes",
];

export function ConsultingPage() {
  useEffect(() => {
    const previous = document.title;
    document.title = "Consulting | Ecological Engineering";
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <section className="section">
      <div className="container">
        <div className="section-head">
          <div>
            <p className="eyebrow">Ecological Engineering · Australia</p>
            <h2>Consulting</h2>
            <p>
              Ecological Engineering delivers environmental and field programmes for site approvals
              and resource projects across Australia.
            </p>
          </div>
        </div>

        <div className="grid-2">
          <article className="card">
            <h3>Capabilities</h3>
            <ul className="check-list">
              {CAPABILITIES.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>

          <article className="card">
            <h3>Contact</h3>
            <p className="muted">
              Email{" "}
              <a href="mailto:info@ecoeng.net">info@ecoeng.net</a>
              {" "}or{" "}
              <a href="mailto:nigel@ecoeng.net">nigel@ecoeng.net</a>.
            </p>
            <p className="muted">
              Tools and guided reports remain available when a download or a reviewed pack is the
              right start.
            </p>
            <div className="service-cta-actions" style={{ marginTop: "1rem" }}>
              <Link className="btn btn-primary" to="/contact">
                Contact form
              </Link>
              <Link className="btn btn-outline" to="/resources">
                Tools and resources
              </Link>
              <Link className="btn btn-outline" to="/reports">
                Guided reports
              </Link>
            </div>
          </article>
        </div>

        <div className="card service-cta-bar" style={{ marginTop: "1.5rem" }}>
          <div>
            <h3 style={{ margin: 0 }}>Need a tool instead?</h3>
            <p className="muted" style={{ margin: "0.35rem 0 0" }}>
              Start with the DIY library or a guided report. Use consulting when the site programme
              needs field coordination or an approvals package.
            </p>
          </div>
          <div className="service-cta-actions">
            <Link className="btn btn-outline btn-sm" to="/resources">
              Browse tools
            </Link>
            <Link className="btn btn-outline btn-sm" to="/pricing">
              Pricing
            </Link>
            <Link className="btn btn-primary btn-sm" to="/contact">
              Enquire
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
